import { getHelpCategoryIcon } from './helpIcons.js';
import {
  resolveInstructionArticleSlug,
  resolveInstructionCategorySlug,
} from './helpSlugRedirects.js';

const HELP_INSTRUCTION_CATEGORIES_TR = [
  {
    slug: 'app-installation',
    title: 'VurgunBet uygulamalarını yükleme',
    desc: 'Android ve iOS için VurgunBet uygulamalarını yükleme.',
    iconKey: 'apps',
    articles: [
      {
        slug: 'ios-installation',
        title: 'iOS uygulamasını yükleme',
        content: [
          'VurgunBet iOS uygulaması, iPhone ve iPad cihazlarınızda spor bahisleri ve canlı casino oyunlarına hızlı erişim sağlar. Uygulama App Store dışında doğrudan VurgunBet sitesinden indirilebilir; kurulum için cihazınızda profil güvenlik ayarlarından geliştirici profiline izin vermeniz gerekebilir.',
          'Kurulum adımları: Safari ile vurgunbet.com adresine gidin, menüden Uygulamalar bölümünü açın ve iOS indirme bağlantısına dokunun. İndirme tamamlandığında Ayarlar → Genel → VPN ve Cihaz Yönetimi üzerinden VurgunBet profilini onaylayın. Uygulamayı açtığınızda mevcut hesabınızla giriş yapabilir veya yeni kayıt oluşturabilirsiniz.',
          'Güncellemeler site üzerinden yayımlandığında uygulama sizi bilgilendirir. Push bildirimleri için iOS ayarlarından VurgunBet\'e bildirim izni verin; maç başlangıçları ve kampanya duyurularını kaçırmazsınız. Sorun yaşarsanız cihazı yeniden başlatın veya destek hattından yardım alın.',
        ],
      },
      {
        slug: 'android-installation',
        title: 'Android uygulamasını yükleme',
        content: [
          'VurgunBet Android uygulaması, APK formatında sunulur ve Google Play dışından güvenli indirme sayfası üzerinden kurulur. Uygulama spor programı, canlı bahis, kupon yönetimi ve hesap işlemlerini tek ekranda toplar.',
          'Kurulum için vurgunbet.com adresindeki Android bağlantısından APK dosyasını indirin. İlk kurulumda Ayarlar → Güvenlik bölümünden bilinmeyen kaynaklara izin vermeniz istenebilir. İndirme tamamlandıktan sonra dosyaya dokunarak kurulumu onaylayın ve uygulamayı açın.',
          'Kurulum sonrası otomatik giriş için parmak izi veya yüz tanıma desteklenen cihazlarda etkinleştirilebilir. Uygulama güncellemelerini düzenli yükleyin; eski sürümlerde canlı bahis gecikmesi veya ödeme ekranı uyumsuzluğu görülebilir. Depolama alanı yetersizse önbelleği temizleyerek yeniden deneyin.',
        ],
      },
      {
        slug: 'shortcut-ana-ekran',
        title: 'Ana ekrana kısayol ekleme',
        content: [
          'Uygulama indirmeden VurgunBet\'e hızlı erişmek için ana ekrana kısayol ekleyebilirsiniz. Bu yöntem hem iOS hem Android tarayıcılarında çalışır ve tek dokunuşla spor ve casino bölümlerine yönlendirir.',
          'iOS\'ta Safari ile siteyi açın, paylaş simgesine dokunun ve Ana Ekrana Ekle seçeneğini seçin. Kısayol adını VurgunBet olarak bırakabilir veya özelleştirebilirsiniz. Android\'de Chrome kullanıyorsanız menüden Ana ekrana ekle veya Kısayol oluştur adımını izleyin.',
          'Kısayol, tam ekran web uygulaması gibi açılır ve adres çubuğu gizlenir. Bildirim almak için tarayıcı bildirimlerine izin verin. Kısayolu silmek için ana ekranda uzun basıp kaldırın; hesap oturumunuz tarayıcıda saklanmaya devam eder.',
        ],
      },
    ],
  },
  {
    slug: 'interface-settings',
    title: 'Arayüz ayarları',
    desc: 'Sitenin ve uygulamanın faydalı özellikleri.',
    iconKey: 'interface',
    articles: [
      {
        slug: 'tema-karanlik-acik',
        title: 'Karanlık ve açık tema',
        content: [
          'VurgunBet hem karanlık hem açık tema sunar. Karanlık tema düşük ışıkta göz yorgunluğunu azaltır; açık tema gündüz kullanımında kontrastı artırır. Tema tercihi hesap ayarlarından veya üst menüdeki görünüm düğmesinden değiştirilebilir.',
          'Seçiminiz tüm cihazlarda oturum açtığınızda senkronize edilir. Uygulama ve mobil site aynı tema ayarını paylaşır. Otomatik tema seçeneği varsa cihazınızın sistem ayarına uyum sağlar.',
          'Tema değişikliği bahis oranlarını veya kupon işleyişini etkilemez; yalnızca arayüz renklerini günceller. Erişilebilirlik için yüksek kontrast modunu birlikte kullanmanız önerilir.',
        ],
      },
      {
        slug: 'site-ozellestirme',
        title: 'Web sitesini özelleştirme',
        content: [
          'VurgunBet web sitesinde varsayılan spor dalı, lig sıralaması ve oran formatını kişiselleştirebilirsiniz. Hesabım → Ayarlar bölümünden ondalık, kesirli veya Amerikan oran görünümünü seçin.',
          'Ana sayfa widget\'larını düzenleyerek canlı maçlar, popüler ligler veya casino lobisini öne çıkarabilirsiniz. Sık kullandığınız marketleri favorilere eklemek kupon oluşturmayı hızlandırır.',
          'Dil seçeneği Türkçe ve İngilizce arasında anında değişir. Saat dilimi ayarı maç saatlerinin yerel saatinize göre gösterilmesini sağlar. Özelleştirmeler tarayıcı önbelleği silinse bile hesabınıza bağlı kalır.',
        ],
      },
      {
        slug: 'ios-ozellestirme',
        title: 'iOS uygulamasını özelleştirme',
        content: [
          'iOS uygulamasında bildirim türlerini ayrı ayrı yönetebilirsiniz: maç başlangıcı, gol, kupon sonucu ve promosyonlar. Ayarlar ekranından yalnızca ilgilendiğiniz spor dalları için uyarı alın.',
          'Biyometrik giriş etkinleştirildiğinde her açılışta şifre girmeniz gerekmez. Canlı bahis ekranında istatistik panelini genişletilmiş veya kompakt modda gösterebilirsiniz. Veri tasarrufu modu animasyonları azaltır.',
          'Uygulama içi tema ve oran formatı web hesabınızla eşleşir. Hücresel veri kullanımını sınırlamak için yalnızca Wi-Fi üzerinden canlı yayın açma seçeneğini işaretleyin.',
        ],
      },
      {
        slug: 'android-ozellestirme',
        title: 'Android uygulamasını özelleştirme',
        content: [
          'Android uygulamasında ana navigasyon çubuğunu spor, canlı ve casino sekmeleriyle kişiselleştirin. Sık ziyaret ettiğiniz ligleri üst sıraya sabitlemek için lig listesinde yıldız simgesini kullanın.',
          'Arka planda oran güncellemesi için pil optimizasyonundan VurgunBet\'i muaf tutun; aksi halde canlı kuponlarda gecikme yaşanabilir. Kupon onayı için titreşim ve ses geri bildirimini ayarlardan açıp kapatabilirsiniz.',
          'Depolama yönetiminden önbelleği temizlemek görüntü sorunlarını çözer; oturum bilgileriniz korunur. Android 13 ve üzeri sürümlerde bildirim izinlerini kategori bazında onaylayın.',
        ],
      },
      {
        slug: 'mobil-site-ozellestirme',
        title: 'Mobil siteyi özelleştirme',
        content: [
          'Mobil tarayıcı sürümü uygulama indirmeden tam bahis deneyimi sunar. Alt menüden spor, canlı ve hesap bölümlerine tek dokunuşla geçebilirsiniz. Yatay modda kupon paneli ekranın altında sabit kalır.',
          'Mobil sitede hızlı bahis modu, tek tıkla önceden belirlediğiniz tutarı koymanızı sağlar. Bu tutarı Hesabım → Bahis ayarlarından değiştirin. Lig ve maç filtreleri dar ekranda kaydırılabilir çip olarak görünür.',
          'Bağlantı hızı düşükse basitleştirilmiş görünüm otomatik devreye girebilir. Siteyi ana ekrana eklediğinizde bu ayarlar korunur. Önbellek sorunlarında tarayıcı geçmişini temizleyip yeniden giriş yapın.',
        ],
      },
      {
        slug: 'favoriler',
        title: 'Favoriler ve takip listesi',
        content: [
          'VurgunBet favoriler özelliğiyle ligleri, takımları ve maçları takip listesine ekleyebilirsiniz. Yıldız simgesine dokunduğunuzda ilgili etkinlikler ana sayfada ve canlı sekmesinde öne çıkar.',
          'Takip ettiğiniz maçlar için push veya tarayıcı bildirimi açabilirsiniz. Favori marketler kupon oluştururken listenin üstünde görünür; örneğin maç sonucu ve 2,5 gol tercihlerinizi kaydedin.',
          'Favori listesi hesabınıza bağlıdır ve cihaz değiştirseniz de senkronize kalır. Listeyi düzenlemek için favoriler panelinde sola kaydırarak kaldırma işlemi yapın. Çok sayıda favori performansı etkileyebilir; yalnızca aktif takip ettiklerinizi tutun.',
        ],
      },
      {
        slug: 'gorme-engelli',
        title: 'Görme engelli kullanıcılar için erişilebilirlik',
        content: [
          'VurgunBet ekran okuyucu uyumlu etiketler ve klavye navigasyonu sunmayı hedefler. iOS VoiceOver ve Android TalkBack ile menü öğeleri, oranlar ve kupon butonları sesli okunabilir.',
          'Yüksek kontrast modu ve büyük yazı tipi ayarları sistem tercihlerinizle uyumludur. Renk körlüğü için yalnızca renge dayalı bilgi taşıyan öğelerde ek metin veya simge bulunur.',
          'Erişilebilirlik geri bildiriminizi destek kanalına iletebilirsiniz. Kupon onayı gibi kritik adımlarda ekran okuyucu odak sırası mantıksal akışı takip eder. Sorun yaşarsanız masaüstü sürümü geçici alternatif olarak kullanılabilir.',
        ],
      },
    ],
  },
];

const HELP_INSTRUCTION_CATEGORIES_EN = [
  {
    slug: 'app-installation',
    title: 'Installing VurgunBet apps',
    desc: 'How to install VurgunBet apps on Android and iOS.',
    iconKey: 'apps',
    articles: [
      {
        slug: 'ios-installation',
        title: 'Installing the iOS app',
        content: [
          'The VurgunBet iOS app gives quick access to sports betting and live casino on iPhone and iPad. It can be downloaded from the VurgunBet website; you may need to trust the developer profile in device settings.',
          'Open vurgunbet.com in Safari, go to Apps and tap the iOS download link. After download, approve the profile under Settings → General → VPN & Device Management, then sign in or register.',
          'Enable push notifications for match starts and promotions. Restart the device or contact support if installation fails.',
        ],
      },
      {
        slug: 'android-installation',
        title: 'Installing the Android app',
        content: [
          'The VurgunBet Android app is distributed as an APK from the official site. It combines sports, live betting, bet slip and account tools in one app.',
          'Download the APK from vurgunbet.com and allow installation from unknown sources if prompted. Open the file to complete setup and sign in.',
          'Keep the app updated and clear cache if storage is low. Biometric login is supported on compatible devices.',
        ],
      },
      {
        slug: 'shortcut-ana-ekran',
        title: 'Add to home screen',
        content: [
          'You can add a home screen shortcut for one-tap access without installing an app. Works in Safari on iOS and Chrome on Android.',
          'On iOS use Share → Add to Home Screen. On Android use the browser menu to add a shortcut.',
          'The shortcut opens like a full-screen web app. Allow browser notifications for alerts.',
        ],
      },
    ],
  },
  {
    slug: 'interface-settings',
    title: 'Interface settings',
    desc: 'Useful site and app features.',
    iconKey: 'interface',
    articles: [
      {
        slug: 'tema-karanlik-acik',
        title: 'Dark and light theme',
        content: [
          'VurgunBet offers dark and light themes. Change the theme in account settings or the header toggle.',
          'Your choice syncs across devices when signed in.',
          'Theme affects only colours, not odds or bet settlement.',
        ],
      },
      {
        slug: 'site-ozellestirme',
        title: 'Customising the website',
        content: [
          'Set default sport, league order and odds format under My Account → Settings.',
          'Rearrange homepage widgets and save favourite markets for faster bet slips.',
          'Language and timezone preferences are stored on your account.',
        ],
      },
      {
        slug: 'ios-ozellestirme',
        title: 'Customising the iOS app',
        content: [
          'Manage notification types for goals, bet results and promotions separately.',
          'Enable biometric login and compact or expanded live stats panels.',
          'Restrict live streams to Wi-Fi to save mobile data.',
        ],
      },
      {
        slug: 'android-ozellestirme',
        title: 'Customising the Android app',
        content: [
          'Pin favourite leagues and customise the bottom navigation bar.',
          'Exclude the app from battery optimisation for timely live odds updates.',
          'Clear cache from storage settings without losing your session.',
        ],
      },
      {
        slug: 'mobil-site-ozellestirme',
        title: 'Customising the mobile site',
        content: [
          'The mobile browser version offers full betting without an app install.',
          'Quick bet mode places a preset stake in one tap.',
          'Simplified view may activate on slow connections.',
        ],
      },
      {
        slug: 'favoriler',
        title: 'Favourites and watchlist',
        content: [
          'Star leagues, teams and matches to surface them on the home and live pages.',
          'Enable alerts for tracked events and favourite markets on the bet slip.',
          'Favourites sync with your account across devices.',
        ],
      },
      {
        slug: 'gorme-engelli',
        title: 'Accessibility',
        content: [
          'VurgunBet aims to support screen readers and keyboard navigation.',
          'High contrast and large text follow system settings.',
          'Report accessibility issues via support; desktop can be used as a fallback.',
        ],
      },
    ],
  },
];

function instructionLocaleKey(locale) {
  return locale === 'en' ? 'en' : 'tr';
}

const INSTRUCTION_CATEGORIES_BY_LOCALE = {
  tr: HELP_INSTRUCTION_CATEGORIES_TR,
  en: HELP_INSTRUCTION_CATEGORIES_EN,
};

export function getInstructionCategories(locale = 'tr') {
  return INSTRUCTION_CATEGORIES_BY_LOCALE[instructionLocaleKey(locale)].map(
    ({ slug, title, desc, iconKey }) => ({
      slug,
      title,
      desc,
      icon: getHelpCategoryIcon(iconKey),
    }),
  );
}

export function getInstructionArticles(catSlug, locale = 'tr') {
  const category = INSTRUCTION_CATEGORIES_BY_LOCALE[instructionLocaleKey(locale)].find(
    (cat) => cat.slug === resolveInstructionCategorySlug(catSlug),
  );
  if (!category) return [];
  return category.articles.map(({ slug, title, content }) => ({ slug, title, content }));
}

export function getInstructionArticle(catSlug, articleSlug, locale = 'tr') {
  const category = INSTRUCTION_CATEGORIES_BY_LOCALE[instructionLocaleKey(locale)].find(
    (cat) => cat.slug === resolveInstructionCategorySlug(catSlug),
  );
  if (!category) return null;
  const article = category.articles.find(
    (item) => item.slug === resolveInstructionArticleSlug(articleSlug),
  );
  if (!article) return null;
  return {
    category: { slug: category.slug, title: category.title, desc: category.desc },
    slug: article.slug,
    title: article.title,
    content: article.content,
  };
}

export { HELP_INSTRUCTION_CATEGORIES_TR, HELP_INSTRUCTION_CATEGORIES_EN };
